<template>
  <div>
    <navbar/>
    <main role="main">
      <div class="jumbotron">
        <div class="container">
          <h1 class="display-3">404 - not found</h1>
          <p>Whoooops! The page you requested was not found. Might be a typo?</p>
        </div>
      </div>
    </main>
    <tlfooter/>
  </div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";

export default {
  name: "NotFound",
  head: {
    title: 'just bookmark it! - not found'
  },
  components: {
    navbar, tlfooter
  }
};
</script>
